import React, { createContext, useContext, useState, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import { KidsPinModal } from "@/components/KidsPinModal";

const KidsContext = createContext(null);
export const useKids = () => useContext(KidsContext);

const KEY = "nikplay_kids";

export function KidsProvider({ children }) {
  const { user } = useAuth();
  const [kidsMode, setKidsMode] = useState(() => localStorage.getItem(KEY) === "1");
  const [modal, setModal] = useState(null); // 'create' | 'exit' | null

  const activate = useCallback(() => {
    localStorage.setItem(KEY, "1");
    setKidsMode(true);
  }, []);

  const deactivate = useCallback(() => {
    localStorage.removeItem(KEY);
    setKidsMode(false);
  }, []);

  const enterKids = useCallback(() => {
    if (user && !user.has_kids_pin) {
      setModal("create");
    } else {
      activate();
    }
  }, [user, activate]);

  const exitKids = useCallback(() => {
    if (user?.has_kids_pin) {
      setModal("exit");
    } else {
      deactivate();
    }
  }, [user, deactivate]);

  const onModalSuccess = useCallback(() => {
    if (modal === "exit") deactivate();
    else activate();
    setModal(null);
  }, [modal, activate, deactivate]);

  return (
    <KidsContext.Provider value={{ kidsMode, enterKids, exitKids }}>
      {children}
      {modal && (
        <KidsPinModal mode={modal} onClose={() => setModal(null)} onSuccess={onModalSuccess} />
      )}
    </KidsContext.Provider>
  );
}
